import Typography from '@mui/material/Typography';
import React, { forwardRef } from 'react';
import { Tooltip } from 'shared/components/ui/tooltip';
import { useForwardedRef } from 'shared/hooks/use-forwarded-ref';

import * as Styled from './task-meta-interaction.style';
import { Colors } from './types';

export type TaskMetaInteractionProps = {
  start?: React.ReactNode;
  startColor?: Colors;
  color?: Colors;
  label?: string;
  placeholder?: string;
  onClick?: (e: React.MouseEvent) => void;
  tooltipLabel?: string;
  selected?: boolean;
  hasTooltip?: boolean;
  isMobileOutlined?: boolean;
  isFrozen?: boolean;
  minimalStartSpacing?: boolean;
  minimalEndSpacing?: boolean;
};

export const TaskMetaInteraction = forwardRef<
  HTMLButtonElement,
  TaskMetaInteractionProps
>(
  (
    {
      start,
      startColor = Colors.Inherit,
      color = Colors.Inherit,
      label,
      placeholder,
      onClick,
      tooltipLabel,
      selected,
      hasTooltip,
      isMobileOutlined,
      minimalStartSpacing,
      minimalEndSpacing,
      isFrozen,
    },
    ref,
  ) => {
    const containerRef = useForwardedRef(ref);

    return (
      <>
        <Styled.Container
          ref={containerRef}
          onClick={!isFrozen ? onClick : undefined}
          as={!isFrozen && onClick ? undefined : 'span'}
          $selected={!!selected}
          $isMobileOutlined={!!isMobileOutlined}
          $isFrozen={!!isFrozen}
          $minimalStartSpacing={!!minimalStartSpacing}
          $minimalEndSpacing={!!minimalEndSpacing}
        >
          {!!start && (
            <Styled.IconContainer $color={startColor}>
              {start}
            </Styled.IconContainer>
          )}

          {(!!label || !!placeholder) && (
            <Styled.Title $color={color}>
              <Typography variant="overline">{label ?? placeholder}</Typography>
            </Styled.Title>
          )}
        </Styled.Container>
        {!!hasTooltip && !!tooltipLabel && !selected && (
          <Tooltip label={tooltipLabel} referenceElement={containerRef} />
        )}
      </>
    );
  },
);
